import { render, staticRenderFns } from "./UpdateCustomerInfoModal.vue?vue&type=template&id=7181d330&scoped=true&"
import script from "./UpdateCustomerInfoModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerInfoModal.vue?vue&type=style&index=0&id=7181d330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181d330",
  null
  
)

export default component.exports